<template>
  <v-card :elevation="0" v-if="0 < graphCount">

    <v-form @submit.prevent ref="form">

      <v-row dense class="px-3">
        <v-col cols="12">
          <v-switch hide-details="true" class="ms-2" color="primary"
            label="色分けゲージの値の範囲を固定" v-model="isShowColorGaugeConfig"></v-switch>
        </v-col>

        <v-col cols="12" class="pb-4" v-if="isShowColorGaugeConfig">

          <v-row dense>
            <v-col :cols="$vuetify.display.mobile ? 4 : 1" class="d-flex align-center justify-center">
              最小値
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 7 : 4">
              <v-text-field variant="outlined" density="compact"
                :rules="[ v => (!!v) || '数値', v => (v && !isNaN(Number(v))) || '数値' ]"
                persistent-hint hint="数値" v-model="colorGaugeMinParam"></v-text-field>
            </v-col>

            <v-col :cols="$vuetify.display.mobile ? 4 : 1" class="d-flex align-center justify-center">
              最大値
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 7 : 4">
              <v-text-field variant="outlined" density="compact"
                :rules="[ v => (!!v) || '数値', v => (v && !isNaN(Number(v))) || '数値' ]"
                persistent-hint hint="数値" v-model="colorGaugeMaxParam"></v-text-field>
            </v-col>

            <v-col :cols="$vuetify.display.mobile ? 12 : 2" class="d-flex align-center justify-center">
              <v-btn :elevation="0" color="primary" class="mt-2 w-75"
                v-on:click="setColorGaugeRange">固定する</v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

    </v-form>

  </v-card>

  <v-container fluid class="px-0">
    <v-row>
      <v-col :cols="$vuetify.display.mobile ? 12 : 6" :key="i" v-for="i of graphCount">
        <contour-plots :elevation="1"
          :index="i"

          :x-min="xMin"
          :x-max="xMax"
          :y-min="yMin"
          :y-max="yMax"

          :devices="devices"

          :is-color-gauge-range-fixed="isColorGaugeRangeFixed"
          :color-gauge-min="colorGaugeMin"
          :color-gauge-max="colorGaugeMax" />
      </v-col>

      <v-col :cols="$vuetify.display.mobile ? 12 : 6" v-show="0 < graphCount && graphCount < 4">
        <v-card variant="outlined" color="grey-lighten-1">
          <v-card-actions class="justify-center">
            <v-btn color="primary" v-on:click="{ graphCount++; }">
              <template v-slot:prepend>
                <v-icon>mdi-plus</v-icon>
              </template>
              <span>グラフを追加</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" class="mt-4" v-if="graphCount > 0">
        <v-card :elevation="0">
          <v-card-actions class="pa-3 justify-end">
            <v-btn variant="tonal" class="px-4" :to="'house-map' + route.hash">
              <template v-slot:prepend>
                <v-icon>mdi-table-large-plus</v-icon>
              </template>
              <span>計測機の配置を編集</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <v-card variant="outlined" max-width="540" class="mx-auto" v-if="graphCount == 0">
    <v-card-title class="mt-1 text-subtitle-1">
      ハウスの情報設定が必要です
    </v-card-title>

    <v-card-text>
      <p class="mt-2">下記のボタンから計測セット設置先のハウスの形状、ログBOXの配置の情報の登録を行ってください。</p>
      <p class="mt-2">すでに設定済みの場合には、保存したURLから再度アクセスしてください。</p>
    </v-card-text>

    <v-card-actions>
      <v-btn variant="tonal" color="primary" class="w-100" to="house-map">
        配置設定画面へ
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, provide, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

import rison from 'rison';

import ContourPlots from '../components/ContourPlots.vue'

export default {
  name: 'MeasurementResult2View',
  components: {
    ContourPlots
  },
  setup() {

    const sharedDate = ref(new Date());
    const sharedHour = ref(sharedDate.value.getHours().toString().padStart(2, '0'));
    const sharedChartTimelineIndex = ref(0);

    provide('shared-date', sharedDate);
    provide('shared-hour', sharedHour);
    provide('shared-chart-timeline-index', sharedChartTimelineIndex);


    const xMin = ref(-0.5);
    const xMax = ref(19.5);
    const yMin = ref(-0.5);
    const yMax = ref(4.5);

    const devices = ref([]);


    const form = ref();

    const isShowColorGaugeConfig = ref(false);

    const colorGaugeMinParam = ref('');
    const colorGaugeMaxParam = ref('');

    const isColorGaugeRangeFixed = ref(false);

    const colorGaugeMin = ref(0);
    const colorGaugeMax = ref(0);

    const graphCount = ref(0);


    const route = useRoute();


    onMounted(() => {

      try {

        if (location.hash.split('#').length < 3) {
          throw new Error();
        }


        const devicesLayout = rison.decode_object(location.hash.split('#')[2]);


        if ('xMin' in devicesLayout && Number.isFinite(devicesLayout.xMin)) {
          xMin.value = devicesLayout.xMin;
        } else { throw new Error(); }

        if ('xMax' in devicesLayout && Number.isFinite(devicesLayout.xMax)) {
          xMax.value = devicesLayout.xMax;

        } else { throw new Error(); }

        if ('yMin' in devicesLayout && Number.isFinite(devicesLayout.yMin)) {
          yMin.value = devicesLayout.yMin;
        } else { throw new Error(); }

        if ('yMax' in devicesLayout && Number.isFinite(devicesLayout.yMax)) {
          yMax.value = devicesLayout.yMax;
        } else { throw new Error(); }


        if (Array.isArray(devicesLayout.d)) {

          devicesLayout.d.forEach((device) => {

            if (!('id' in device) || !Number.isInteger(device.id)) { throw new Error(); }

            // TBD データ参照権限のチェック


            if (!('x' in device) || !Number.isFinite(device.x)) { throw new Error(); }

            if (!('y' in device) || !Number.isFinite(device.y)) { throw new Error(); }

          });

        } else { throw new Error(); }

        devices.value = devicesLayout.d;


        graphCount.value = 1;

      } catch {

        // TBD

      }


      watch(isShowColorGaugeConfig, () => {
        if (!isShowColorGaugeConfig.value) {

          isColorGaugeRangeFixed.value = false;

        }
      });

    });

    const setColorGaugeRange = async () => {

      const { valid } = await form.value.validate();
      if (!valid) {
        return;
      }

      if (Number(colorGaugeMinParam.value) > Number(colorGaugeMaxParam.value)) {
        let tmp = colorGaugeMaxParam.value;
        colorGaugeMaxParam.value = colorGaugeMinParam.value;
        colorGaugeMinParam.value = tmp;
      }


      isColorGaugeRangeFixed.value = true;

      colorGaugeMin.value = Number(colorGaugeMinParam.value);
      colorGaugeMax.value = Number(colorGaugeMaxParam.value);

    };


    return {
      xMin,
      xMax,
      yMin,
      yMax,

      devices,


      form,

      isShowColorGaugeConfig,

      colorGaugeMinParam,
      colorGaugeMaxParam,

      isColorGaugeRangeFixed,

      colorGaugeMin,
      colorGaugeMax,

      graphCount,

      route,

      setColorGaugeRange
    }
  }
}
</script>
